import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPGalleryInteractedEvent from 'data-hooks/useEvents/usePDPGalleryInteractedEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPMobileStudioPhotoGalleryUI from './PDPMobileStudioPhotoGalleryUI';
const PDPMobileStudioPhotoGalleryInner = t0 => {
  const $ = _c(19);
  const {
    pdpIsModularBYOProduct: t1,
    linkTo,
    mode: t2,
    slug,
    productHeroImage: t3,
    productCylindoHeroImage: t4
  } = t0;
  const pdpIsModularBYOProduct = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const productCylindoHeroImage = t4 === undefined ? null : t4;
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData
  } = usePDPPhotos(null, slug);
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    resetGalleryImageTracking,
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  const {
    trackGalleryInteracted
  } = usePDPGalleryInteractedEvent();
  const t5 = !pdpIsModularBYOProduct;
  let t6;
  if ($[0] !== t5) {
    t6 = {
      skip: t5
    };
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let modularPhotosData = useModularPDPPhotos(null, slug, t6);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const ssrHeroSrc = productHeroImage?.src || productCylindoHeroImage?.src || null;
  if (photosLoading || basicDetailsLoading || pdpIsModularBYOProduct && modularPhotosData.loading) {
    if (ssrHeroSrc) {
      const t7 = productHeroImage?.alt || productCylindoHeroImage?.alt || "";
      const t8 = productHeroImage?.width || 800;
      const t9 = productHeroImage?.height || 800;
      let t10;
      if ($[2] !== ssrHeroSrc || $[3] !== t7 || $[4] !== t8 || $[5] !== t9) {
        t10 = <RatioContainer><img className="h-full w-full object-contain object-center select-none" src={ssrHeroSrc} alt={t7} width={t8} height={t9} loading="eager" fetchPriority="high" decoding="async" /></RatioContainer>;
        $[2] = ssrHeroSrc;
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
        $[6] = t10;
      } else {
        t10 = $[6];
      }
      return t10;
    }
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    return t7;
  }
  if (photosError || basicDetailsError) {
    return null;
  }
  const {
    studioPhotos,
    enableCrops,
    introVideoIds
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;
  const {
    name
  } = basicDetailsData;
  const t7 = basicDetailsData?.custom_properties?.campaign;
  const t8 = introVideoIds?.desktop;
  let t9;
  if ($[8] !== enableCrops || $[9] !== linkTo || $[10] !== mode || $[11] !== name || $[12] !== resetGalleryImageTracking || $[13] !== studioPhotos || $[14] !== t7 || $[15] !== t8 || $[16] !== trackGalleryInteracted || $[17] !== viewGalleryImageEvent) {
    t9 = <PDPMobileStudioPhotoGalleryUI campaign={t7} enableCrops={enableCrops} introVideoId={t8} linkTo={linkTo} mode={mode} photos={studioPhotos} productName={name} resetGalleryImageTracking={resetGalleryImageTracking} trackGalleryInteracted={trackGalleryInteracted} viewGalleryImageEvent={viewGalleryImageEvent} />;
    $[8] = enableCrops;
    $[9] = linkTo;
    $[10] = mode;
    $[11] = name;
    $[12] = resetGalleryImageTracking;
    $[13] = studioPhotos;
    $[14] = t7;
    $[15] = t8;
    $[16] = trackGalleryInteracted;
    $[17] = viewGalleryImageEvent;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
PDPMobileStudioPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
const PDPMobileStudioPhotoGallery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPMobileStudioPhotoGalleryInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobileStudioPhotoGallery;